import { defineMessages } from 'react-intl-next';

export const nativeTabsToolbarMessages = defineMessages({
	tabs: {
		id: 'editor-plugin-native-tabs-toolbar.tabs',
		defaultMessage: 'Tabs',
		description:
			'Toolbar button label shown in the editor toolbar. Allows users to insert tabs into the document.',
	},
});
